import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  List, 
  ListItem, 
  ListItemText, 
  Link, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails,
  useMediaQuery,
  Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material/styles';

const Links = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Data structure for footer section 1
  const footerSection1 = [
    {
      title: "Dubai Properties",
      links: [
        { text: "Desco", url: "#" },
        { text: "Career @ Desco", url: "#" },
        { text: "Contact Us", url: "#" },
        { text: "Location Map", url: "#" },
        { text: "Dubai Real Estate Blog", url: "#" },
        { text: "Dubai Real Estate FAQs", url: "#" },
        { text: "Top Real Estate Developers in Dubai", url: "#" },
        { text: "Dubai Property Management", url: "#" },
        { text: "Dubai Property Score", url: "#" },
        { text: "Loan Mortgage Calculator", url: "#" },
        { text: "Dubai property prices 2024", url: "#" },
      ]
    },
    {
      title: "Dubai Properties for Sale",
      links: [
        { text: "Dubai Penthouse for Sale", url: "#" },
        { text: "Dubai Mansion for Sale", url: "#" },
        { text: "Dubai Apartment for Sale", url: "#" },
        { text: "Dubai Villa for Sale", url: "#" },
        { text: "Houses for Sale in Dubai", url: "#" },
        { text: "Plot in Dubai", url: "#" },
        { text: "Office for sale in Dubai", url: "#" },
        { text: "Buy Ready Apartments in Dubai", url: "#" },
        { text: "Buy Ready Villas in Dubai", url: "#" },
        { text: "Townhouse for Sale in Dubai", url: "#" },
        { text: "Buy Ready Townhouses in Dubai", url: "#" },
      ]
    },
    {
      title: "Dubai Properties for Rent",
      links: [
        { text: "Dubai Penthouse for Rent", url: "#" },
        { text: "Dubai Apartment for Rent", url: "#" },
        { text: "Dubai Villa for Rent", url: "#" },
        { text: "Office in Dubai for Rent", url: "#" },
        { text: "Townhouse for Rent in Dubai", url: "#" },
        { text: "Houses for Rent in Dubai", url: "#" },
        { text: "Furnished Apartments for Rent", url: "#" },
        { text: "Furnished Villas for Rent", url: "#" },
        { text: "Furnished Townhouses for Rent", url: "#" },
        { text: "Rent Your Property in Dubai", url: "#" },
      ]
    },
    {
      title: "Furnished Properties",
      links: [
        { text: "Furnished Studio For Sale", url: "#" },
        { text: "Furnished 1 Bed Apartment For Sale", url: "#" },
        { text: "Furnished 2 Bed Apartment For Sale", url: "#" },
        { text: "Furnished 3 Bed Apartment For Sale", url: "#" },
        { text: "Furnished 4 Bed Apartment For Sale", url: "#" },
        { text: "Furnished Studio For Rent", url: "#" },
        { text: "Furnished 1 Bed Apartment For Rent", url: "#" },
        { text: "Furnished 2 Bed Apartment For Rent", url: "#" },
        { text: "Furnished 3 Bed Apartment For Rent", url: "#" },
        { text: "Furnished 4 Bed Apartment For Rent", url: "#" },
      ]
    },
  ];

  // Data structure for footer section 2
  const footerSection2 = [
    {
      title: "Luxury Properties",
      links: [
        { text: "Luxury Apartments For Sale", url: "#" },
        { text: "Luxury Villas For Sale", url: "#" },
        { text: "Luxury Homes For Sale", url: "#" },
        { text: "Luxury Penthouses For Sale", url: "#" },
        { text: "Luxury Apartments For Rent", url: "#" },
        { text: "Luxury Villas For Rent", url: "#" },
        { text: "Luxury Homes For Rent", url: "#" },
        { text: "Luxury Penthouses For Rent", url: "#" },
      ]
    },
    {
      title: "Beachfront & Waterfront Properties",
      links: [
        { text: "Beachfront Properties for Sale", url: "#" },
        { text: "Beachfront Properties for Rent", url: "#" },
        { text: "Waterfront Properties for Sale", url: "#" },
        { text: "Waterfront Properties for Rent", url: "#" },
        { text: "Beachfront Villas for Sale", url: "#" },
        { text: "Beachfront Villas for Rent", url: "#" },
        { text: "Beachfront Apartments for Sale", url: "#" },
        { text: "Beachfront Apartments for Rent", url: "#" },
      ]
    },
    {
      title: "Off Plan Property Dubai",
      links: [
        { text: "Buy Off plan Apartments in Dubai", url: "#" },
        { text: "Buy Off plan Villas in Dubai", url: "#" },
        { text: "Buy Off plan Townhouses in Dubai", url: "#" },
        { text: "Off plan Projects in Dubai", url: "#" },
        { text: "Off plan Villa Projects in Dubai", url: "#" },
        { text: "Off plan Apartment Projects in Dubai", url: "#" },
        { text: "Off plan Townhouse Projects in Dubai", url: "#" },
      ]
    },
    {
      title: "Dubai Living Experiences",
      links: [
        { text: "Dubai Living", url: "#" },
        { text: "Beachfront", url: "#" },
        { text: "Waterfront", url: "#" },
        { text: "Downtown", url: "#" },
        { text: "Golf Course", url: "#" },
        { text: "Island Living", url: "#" },
        { text: "Green Nature Living", url: "#" },
        { text: "Business Center", url: "#" },
      ]
    },
  ];

  // Function to render a section
  const renderSection = (sectionData) => {
    if (isMobile) {
      return (
        <Box sx={{ backgroundColor: "#f6f6f6",px:2}}>
          {sectionData.map((section, index) => (
            <Accordion key={index} elevation={0} sx={{ '&:before': { display: 'none' } }}>
              <AccordionSummary 
                expandIcon={<ExpandMoreIcon />}
                sx={{ 
                  px: 1, 
                  borderBottom: '1px solid', 
                  borderColor: 'divider',
                  '&.Mui-expanded': {
                    minHeight: 48
                  }
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  {section.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 0 }}>
                <List disablePadding>
                  {section.links.map((link, linkIndex) => (
                    <ListItem key={linkIndex} disablePadding sx={{ py: 0.5 }}>
                      <Link 
                        href={link.url} 
                        // color="primary"
                        underline="hover"
                        sx={{ fontSize: '0.9rem',textDecorationLine: 'none',color:'black' }}
                      >
                        {link.text}
                      </Link>
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      );
    } else {
      return (
        <Grid container spacing={4}>
          {sectionData.map((section, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                {section.title}
              </Typography>
              <List disablePadding>
                {section.links.map((link, linkIndex) => (
                  <ListItem key={linkIndex} disablePadding sx={{ py: 1 }}>
                    <Link 
                      href={link.url} 
                    //   color="primary"
                      underline="hover"
                      sx={{ fontSize: '0.9rem',textDecorationLine: 'none' ,color:'black'}}
                    >
                      {link.text}
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Grid>
          ))}
        </Grid>
      );
    }
  };

  return (
    <Box component="footer" sx={{ py: 6, backgroundColor: "#f6f6f6", }}>
      <Container maxWidth="lg">
        {/* First section */}
        {renderSection(footerSection1)}
        
        {/* Divider */}
        <Divider sx={{ my: 5 }} />
        
        {/* Second section */}
        {renderSection(footerSection2)}
      </Container>
    </Box>
  );
};

export default Links;